<template>
  <footer class="footer">
    <div class="container">
      <nav>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://onewoorks-solutions.com" target="_blank"
          >Onewoorks Solutions</a
        >, developed with <i class="fa fa-heart heart"></i> for a better web solutions
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
